@if (boxed) {
  <icz-section boxed label="Rozsah dokumentu">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </icz-section>
}
@else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  @if (isAnalogDocument || isHybridDocument) {
    <div class="row">
      <icz-form-field label="Počet listinných součástí" class="grow" [value]="complexPaperComponentsCounts" [fieldDisabled]="true">
        <icz-icon suffix svgIcon="info" iczTooltip="fe.ui.complexPaperComponentsCountsHelp"></icz-icon>
      </icz-form-field>
      <icz-form-field label="Počet nelistinných součástí" class="grow" [value]="nonPaperAnalogComponentsSum" [fieldDisabled]="true"></icz-form-field>
    </div>
  }
  @if (isDigitalDocument || isHybridDocument) {
    <icz-form-field label="Počet digitálních komponent dokumentu" [value]="digitalComponentCount" [fieldDisabled]="true"></icz-form-field>
  }

  @if (isOwnDocument) {
    <icz-form-field label="Počet digitálních komponent zásilek" [value]="consignmentDigitalComponentsCount" [fieldDisabled]="true"></icz-form-field>
  }
  @else if (isReceivedDocument) {
    <icz-form-field label="Počet digitálních komponent zásilky" [value]="consignmentDigitalComponentsCount" [fieldDisabled]="true"></icz-form-field>
  }

  <icz-form-field label="Celkový počet digitálních komponent" [value]="totalDigitalComponentsCount" [fieldDisabled]="true"></icz-form-field>
</ng-template>
